// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant, { Toast, Notify, Swipe, SwipeItem } from 'vant'
import 'vant/lib/index.css'

import 'lib-flexible'
import '@/style/reset.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import VueWechatTitle from 'vue-wechat-title'

import 'vant/lib/toast/style'
import 'vant/lib/notify/style'
import VueLazyload from 'vue-lazyload'
import axios from 'axios'

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
// import Vconsole from 'Vconsole'
// const vConsole = new Vconsole();
// Vue.use(vConsole)

Vue.prototype.axios = axios

Vue.use(VueWechatTitle)
Vue.use(Vant)
Vue.use(Toast)
Vue.use(Notify)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(VueAwesomeSwiper)

// 添加VueLazyload 选项
Vue.use(VueLazyload, {
    preLoad: 1.3,
    loading: require('./assets/images/loading-bars.svg'),
    attempt: 1
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js